'use client'

import { useEffect } from 'react'

export const FormSubscribe = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js'
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'eu1',
          portalId: '7759219',
          formId: 'b1f60c4e-2d52-4aac-b9cf-7104ec61ed64',
          target: '#formSubscribe',
        })
      }
    })
  }, [])

  return <div id="formSubscribe" className="formSubscribe"></div>
}
